(ns iris.posts.actions
  (:require
   [re-frame.core :as re-frame]
   [clojure.string :as string]
   [iris.events :as events]
   [iris.globals :as globals]
   [iris.posts.common :refer [ruid-to-ahref]]))

(def http-complete-event :iris.posts.events/http-complete)
(def push-admin-moderation-log-event :iris.posts.events/push-admin-moderation-log)
(def set-admin-all-moderation-logs-event :iris.posts.events/set-admin-all-moderation-logs)
(def http-reload-post-event :iris.posts.events/http-reload-post)

(def http-post-action-success-event :iris.posts.events/http-post-action-success)
(def http-post-action-failure-event :iris.posts.events/http-post-action-failure)
(def http-post-remove-event :iris.posts.events/http-post-remove)
(def http-post-approve-event :iris.posts.events/http-post-approve)
(def http-post-hide-event :iris.posts.events/http-post-hide)
(def http-post-unhide-event :iris.posts.events/http-post-unhide)
(def http-post-enable-replying-event :iris.posts.events/http-post-enable-replying)
(def http-post-disable-replying-event :iris.posts.events/http-post-disable-replying)
(def http-post-qc-pass-event :iris.posts.events/http-post-qc-pass)
(def http-post-qc-fail-event :iris.posts.events/http-post-qc-fail)
(def http-post-publish-event :iris.posts.events/http-post-publish)

(def post-action-api-msg-options
  {:result-modifier-fn (fn [msg] (ruid-to-ahref msg))})

;; TODO: analize get-post-action-outcome-updated-db, perhaps things could be simplified greatly using decode state and updating like we do in post-logs-update
;; TODO: multimethods and posts state data will need to be updated for isLocked and isHidden...
;; ...so :hidden and :replying_disabled become :isHidden and :isLocked in both rpc result handling and [:posts :data]
(defmulti get-post-action-outcome-updated-db
  (fn [_db data]
    (let [method (get-in data [:result :method])]
      (cond (contains? #{"Post.Approve"
                         "Post.Remove"
                         "Post.QCFail"
                         "Post.QCPass"
                         "Post2.Approve"
                         "Post2.Remove"
                         "Post2.QCFail"
                         "Post2.QCPass"
                         "Post.Publish"
                         "Post2.Publish"} method)
            :status
            (contains? #{"Post.Hide"
                         "Post.Unhide"
                         "Post2.Hide"
                         "Post2.Unhide"} method)
            :isHidden
            (contains? #{"Post.Unlock"
                         "Post.Lock"
                         "Post2.Unlock"
                         "Post2.Lock"} method)
            :isLocked))))

(defmethod get-post-action-outcome-updated-db :status [db data]
  (if-let [ruid (get-in data [:result :data :ruid])]
    (let [ruid-parts (string/split ruid #"\+")
          ruid-prefix (first ruid-parts)
          ruid-suffix (second ruid-parts)
          status (get-in data [:result :data :status])
          uid (:uid @globals/jwt-payload)]
      (assoc-in db [:posts :data]
                (mapv #(cond
                         (= ruid (:ruid %))
                         (conj %
                               {:status status
                                :isQc true
                                :qc_by uid})

                         (and (and (= status "R") (= ruid-prefix "@OP"))
                              (= (str "+" ruid-suffix) (:thread %))
                              (= (:status %) "P"))
                         (conj % {:status "T"})

                         (and (= status "P") (= ruid-prefix "@OP")
                              (= (str "+" ruid-suffix) (:thread %))
                              (= (:status %) "T"))
                         (conj % {:status "P"})

                         :else
                         %)
                      (get-in db [:posts :data]))))
    db))

(defmethod get-post-action-outcome-updated-db :isHidden [db data]
  (if-let [ruid (get-in data [:result :data :ruid])]
    (let [hidden (get-in data [:result :data :isHidden])]
      (assoc-in db [:posts :data]
                (mapv #(if (= ruid (:ruid %))
                         (conj % {:isHidden hidden})
                         %)
                      (get-in db [:posts :data]))))
    db))

(defmethod get-post-action-outcome-updated-db :isLocked [db data]
  (if-let [ruid (get-in data [:result :data :ruid])]
    (let [locked (get-in data [:result :data :isLocked])]
      (assoc-in db [:posts :data]
                (mapv #(if (= ruid (:ruid %))
                         (conj % {:isLocked locked})
                         %)
                      (get-in db [:posts :data]))))
    db))

(defmethod get-post-action-outcome-updated-db :default [db _data]
  db)

(def method-to-action-map {:Approve "APPROVE"
                           :Remove "REMOVE"
                           :QCFail "QC_FAIL"
                           :QCPass "QC_PASS"
                           :Hide "HIDE"
                           :Unhide "UNHIDE"
                           :Lock "LOCK"
                           :Unlock "UNLOCK"
                           :Publish "PUBLISH"})

(defn get-log-data-from-post-action-response-data [data]
  (when-let [method (get-in data [:result :method])]
    (let [action (get method-to-action-map (keyword (second (string/split method #"\."))))
          ruid (get-in data [:result :data :ruid])
          state0 (get-in data [:result :antecedent :state])
          state1 (get-in data [:result :data :state])
          dt (get-in data [:result :data :timeUpdated])
          ms (.valueOf (new js/Date dt))]
      ;; TODO: had to add check for ruid, state0 and state1 becase Post2.Publish is not returning these values in api response
      ;; therefore it was crashing app when personal moderator logs were clicked on
      (when (and ruid state0 state1)
        {:action action
         :ruid ruid
         :dt dt
         :ms ms
         :state0 state0
         :state1 state1}))))

(re-frame/reg-event-fx
 http-post-action-success-event
 [(events/api-msg-interceptor (assoc post-action-api-msg-options
                                     :id :http-post-action-success-api-msg-interceptor))]
 (fn [{:keys [db]} [_ ruid data]]
   (let [log-data (get-log-data-from-post-action-response-data data)
         old-log-data (when log-data
                        (get-in db [:posts :all-moderation-log-data (keyword (:ruid log-data))]))
         new-log-data (when log-data
                        (conj old-log-data (assoc log-data :uid (:uid @globals/fbjwt-payload))))
         loaded-post (first (filter #(= ruid (:ruid %)) (get-in db [:posts :data])))
         reload? (and (= (:status loaded-post) "S")
                      (not= (get-in data [:result :data :status]) "S"))
         dispatches (cond-> [[http-complete-event]]
                      log-data
                      (conj [push-admin-moderation-log-event log-data]
                            [set-admin-all-moderation-logs-event (:ruid log-data) new-log-data])
                      reload?
                      (conj [http-reload-post-event ruid]))]
     {:db (get-post-action-outcome-updated-db db data)
      :fx (mapv (fn [event] [:dispatch event]) dispatches)})))

(re-frame/reg-event-fx
 http-post-action-failure-event
 [(events/api-msg-interceptor {})]
 (fn [{:keys [db]}]
   {:db db
    :fx [[:dispatch [http-complete-event]]]}))

(defn- post-action-rpc [method data ruid]
  (events/post-rpc {:jsonrpc "2.0"
                    :id 0
                    :method method
                    :params {:options {:debug false}
                             :data data}}
                   [http-post-action-success-event ruid]
                   [http-post-action-failure-event]
                   nil
                   post-action-api-msg-options))

(re-frame/reg-event-fx
 http-post-remove-event
 (fn [_ [_ ruid]]
   (post-action-rpc "Post2.Remove" {:enqueue false :ruid ruid} ruid)))

(re-frame/reg-event-fx
 http-post-approve-event
 (fn [_ [_ ruid]]
   (post-action-rpc "Post2.Approve" {:enqueue false :ruid ruid} ruid)))

(re-frame/reg-event-fx
 http-post-hide-event
 (fn [_ [_ ruid]]
   (post-action-rpc "Post2.Hide" ruid ruid)))

(re-frame/reg-event-fx
 http-post-unhide-event
 (fn [_ [_ ruid]]
   (post-action-rpc "Post2.Unhide" ruid ruid)))

(re-frame/reg-event-fx
 http-post-enable-replying-event
 (fn [_ [_ ruid]]
   (post-action-rpc "Post2.Unlock" ruid ruid)))

(re-frame/reg-event-fx
 http-post-disable-replying-event
 (fn [_ [_ ruid]]
   (post-action-rpc "Post2.Lock" ruid ruid)))

(re-frame/reg-event-fx
 http-post-qc-pass-event
 (fn [_ [_ ruid]]
   (post-action-rpc "Post2.QCPass" [ruid] ruid)))

(re-frame/reg-event-fx
 http-post-qc-fail-event
 (fn [_ [_ ruid]]
   (post-action-rpc "Post2.QCFail" [ruid] ruid)))

(re-frame/reg-event-fx
 http-post-publish-event
 (fn [_ [_ ruid]]
   (post-action-rpc "Post2.Publish" [ruid] ruid)))
